module.exports = __webpack_public_path__ + "assets/4f225c34003450aa2fb9bbb496f175e9.png";